import React, { Component } from "react";
import selectn from "selectn";

import Headline from "../Headline";
import styles from "./EventCard.css";

class EventCard extends Component {
  render() {
    const { story, isLastStory } = this.props;
    if (!story) return null;
    const image = selectn("primary_image.crops.1x1.url", story);

    return (
      <div>
        <div key={story.id} className={styles.root}>
          {image && <img className={styles.image} src={image} alt={story.primary_image.alt_text}/>}
          <div>
            <Headline
              headline={story.headline}
              permalink={story.permalink} />
            <div className={styles.description}>{story.og_description}</div>
          </div>
        </div>
        {!isLastStory && <hr className={styles.separator} aria-hidden={true}/>}
      </div>
    );
  }
}

export default EventCard;
